import { lazy } from 'react';

const QuotesList = lazy(() => import('./QuotesList'));

const QuotesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'quotes',
      element: <QuotesList />,
    },
  ],
};

export default QuotesConfig;
